import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'
import { STATUSES } from '@/const/status'

export default {
  namespaced: true,
  state: {
    departments: [],
    totalRows: 0,
    statuses: STATUSES,
  },
  getters: {
    departments: state => state.departments,
    totalRows: state => state.totalRows,
    statuses: state => state.statuses,
  },
  mutations: {
    SET_DEPARTMENTS: (state, { total, records }) => {
      state.totalRows = total
      state.departments = records
    },
  },
  actions: {
    async readDepartments({ commit }, params) {
      try {
        const response = await axios.get('uni/departments', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          const { total, records } = data.data
          commit('SET_DEPARTMENTS', { total, records })
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async createDepartments({ commit }, params) {
      try {
        const response = await axios.post('uni/departments', params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async updateDepartments({ commit }, params) {
      try {
        const response = await axios.put(`uni/departments/${params.id}`, params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async deleteDepartments({ commit }, id) {
      try {
        const response = await axios.delete(`uni/departments/${id}`)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
  },
}
